  
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { FindUsersResponse, Params } from "../../types/Types";

export function useFindUsers({
  enabled = true,
  pageSize = 10,
  page = 1,
  searchTerm,
  cities,
  sectors,
  turnovers,
  countries,
  membershipNames,
  stripeStatus,
  activeOnly = false,
  userType = "all",
  discoverableOnly = false,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: [
      "users",
      {
        pageSize,
        page,
        searchTerm,
        discoverableOnly,
        cities,
        sectors,
        turnovers,
        countries,
        membershipNames,
        stripeStatus,
        activeOnly,
        userType,
      },
    ],
    queryFn: async () => {
      let url = getAPIURL(`/User/All?pageNumber=${page}&pageSize=${pageSize}`);

      if (discoverableOnly === true) {
        url += `&discoverableOnly=true`;
      }

      if (userType && userType !== "all") {
        url += `&userType=${encodeURIComponent(userType)}`;
      }

      if (searchTerm) {
        url += `&searchTerm=${encodeURIComponent(searchTerm)}`;
      }

      const resolvedStripeStatus =
        (stripeStatus || "").trim() ||
        (activeOnly === true ? "active" : "");
      if (resolvedStripeStatus) {
        url += `&stripeStatus=${encodeURIComponent(resolvedStripeStatus)}`;
      }
      
      // Add multiple filter values as query parameters
      if (cities && cities.length > 0) {
        cities.forEach(city => {
          url += `&cities=${encodeURIComponent(city)}`;
        });
      }
      
      if (sectors && sectors.length > 0) {
        sectors.forEach(sector => {
          url += `&sectors=${encodeURIComponent(sector)}`;
        });
      }
      
      if (turnovers && turnovers.length > 0) {
        turnovers.forEach(turnover => {
          url += `&turnovers=${encodeURIComponent(turnover)}`;
        });
      }
      
      if (countries && countries.length > 0) {
        countries.forEach(country => {
          url += `&countries=${encodeURIComponent(country)}`;
        });
      }

      if (membershipNames && membershipNames.length > 0) {
        membershipNames.forEach((name) => {
          url += `&membershipNames=${encodeURIComponent(name)}`;
        });
      }
      
      return axiosInstance<FindUsersResponse>(url).then((res) => res.data);
    },
  });
}